<template>
  <div class="warp">
    <div class="leftwarp">
      <div class="uploadwarp">
        <FileUpload
          ref="fileUploadRef"
          @addfilecomplete="handleAddFileComplete"
          @dragenter="handleDragenter"
          @dragleave="handleDragleave"
          :projectId="currentProjectId"
        ></FileUpload>
      </div>
      <div>
        <FileClass @changeClass="handleChangeClass"></FileClass>
      </div>
    </div>
    <div style="flex: 1; position: relative">
      <FileView ref="fileViewRef" :filetype="filetype"></FileView>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import FileClass from "./FileDistribution/FileClass.vue";
import FileUpload from "./FileDistribution/FileUpload.vue";
import FileView from "./FileDistribution/FileView.vue";

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);
watch(
  currentProjectId,
  (val) => {
    if (val && fileViewRef.value) {
      fileViewRef.value.loadFileList();
    }
  },
  { immediate: true }
);

const fileViewRef = ref(null);

const filetype = reactive({
  name: "全部",
  value: "",
});
function handleChangeClass(obj) {
  filetype.name = obj.name;
  filetype.value = obj.value;
  fileViewRef.value.loadFileList();
}
function handleAddFileComplete() {
  fileViewRef.value.loadFileList();
}
function handleDragenter(e) {
  fileViewRef.value.showDarg();
}
function handleDragleave(e) {
  fileViewRef.value.hideDrag();
}

const fileUploadRef = ref(null);
onMounted(() => {
  if (currentProjectId.value) {
    fileViewRef.value.loadFileList();
  }
  fileUploadRef.value.bindDrap(document.getElementById("uploadfileview"));
});
onBeforeUnmount(() => {
  fileUploadRef.value.unBindUploadDrop(
    document.getElementById("uploadfileview")
  );
});
</script>

<style scoped lang="scss">
.warp {
  border: 0px solid #d9d9d9;
  background: #ffffff;
  height: calc(100vh - 90px);
  display: flex;
  position: relative;
  margin: 20px;
}

.leftwarp {
  border-right: 1px solid #e5e5e5;
  height: 100%;
  width: 250px;
}

.uploadwarp {
  height: 60px;
  border-bottom: 1px solid #e5e5e5;
}
</style>
